import { render } from "./Favorite.vue?vue&type=template&id=658e6cb4&scoped=true"
import script from "./Favorite.vue?vue&type=script&lang=js"
export * from "./Favorite.vue?vue&type=script&lang=js"

import "./Favorite.vue?vue&type=style&index=0&id=658e6cb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658e6cb4"]])

export default __exports__